import Tooltip from '@material-ui/core/Tooltip';
import React, { useEffect, useState } from 'react';
import OneSignal from 'react-onesignal';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';

import DesignSelectionModal from '@features/design/components/DesignSelectionModal';
import SelectFolderPopup from '@features/favourites/components/SelectFolderPopup';

import { clearAllChats } from '@store/actions/ChatAction';
import { fetchProductInfo } from '@store/actions/DesignToolAction';
import { likeProduct } from '@store/design/action';

import { addImageSuffix, getUserInfo, onErrorImageLoad } from '@utils/Util';

import { clearDesignViewModalInfo, setDesignViewModalInfo } from '@/store/actions/DesignViewModalAction';

const TopHeader = ({
	activeTab,
	productId,
	openCommentPanel,
	setOpenCommentPanel,
	loader,
	saveAllCanvasData,
	renderDesignSaveStatus,
	stompClient,
	onChangeActiveTab,
	setConvertedImage
}) => {
	const [openModal, setOpenModal] = useState(false);
	const [referenceNumber, setReferenceNumber] = useState('');
	const [productImage, setProductImage] = useState('');
	const designToolStore = useSelector((store) => store.designToolStore);
	const [noOfUnreadMessage, setNoOfUnreadMessage] = useState(null);
	const isNewPost = useSelector((store) => store.chatReducer.newMessage);
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { id } = useParams();
	const [isLiked, setIsLiked] = useState(false);
	const [isShowFavouritePopup, setIsShowFavouritePopup] = useState(false);
	const [isShowCreateNewFolder, setIsShowCreateNewFolder] = useState(false);
	const [currentLikedStyle, setCurrentLikedStyle] = useState(null);
	const [isShowTooltip, setIsShowTooltip] = useState(true);
	const { search } = useLocation();

	useEffect(() => {
		const params = new URLSearchParams(search);
		const isOpenTechpackViewModal = params.get('isOpenTechpackViewModal');
		if (isOpenTechpackViewModal) {
			openDesignViewModal();
		}
	}, [search]);

	useEffect(() => {
		const timer = setTimeout(() => {
			setIsShowTooltip(false);
		}, 5000);

		return () => {
			clearTimeout(timer);
		};
	}, []);

	useEffect(() => {
		setIsLiked(designToolStore?.liked);
		if (designToolStore?.referenceNumber) {
			setReferenceNumber(designToolStore?.referenceNumber);
		}
		if (designToolStore?.designDocuments?.[0]?.docUrl) {
			setProductImage(designToolStore?.designDocuments?.[0]?.docUrl);
		}
	}, [designToolStore]);

	const onLikeProduct = async () => {
		setCurrentLikedStyle(id);
		setIsShowFavouritePopup(true);
		const response = await dispatch(likeProduct(id));
		if (!response) {
			setIsLiked(false);
		} else {
			setIsLiked(true);
		}
	};

	useEffect(() => {
		setNoOfUnreadMessage(designToolStore?.noOfUnreadMessage || null);
	}, [designToolStore?.noOfUnreadMessage]);

	const handleGoBackRoute = () => {
		let fromRoute = localStorage.getItem('fromRoute') ? localStorage.getItem('fromRoute') : navigate(-1);
		navigate(fromRoute);
	};

	useEffect(() => {
		if (designToolStore?.id) {
			const params = `${productId}?checkBuyerSelectionStatus=true`;
			dispatch(fetchProductInfo(params));
		}
	}, [id]);

	const handleRoute = (value) => {
		setOpenCommentPanel(false);
		const params = `${productId}?checkBuyerSelectionStatus=true`;
		dispatch(fetchProductInfo(params));
		if (onChangeActiveTab) onChangeActiveTab(value);
	};

	const handleNavigation = async (tabName) => {
		if (saveAllCanvasData) {
			await saveAllCanvasData(false, true);
		}
		handleRoute(tabName);
	};

	const logout = async () => {
		try {
			OneSignal.removeExternalUserId();
			await stompClient.disconnect(function () {});
			navigate('/logout');
		} catch {
			/* Empty Block */
		}
	};

	const renderProductImage = () => {
		if (designToolStore?.allImageDocuments || productImage) {
			return (
				<img
					src={addImageSuffix(designToolStore?.designDocuments?.[0]?.docUrl || productImage, '')}
					onError={(e) =>
						onErrorImageLoad(e, designToolStore?.designDocuments[0]?.docUrl, 'product')
					}
					className="design-thambnail"
				/>
			);
		}
	};
	const onCloseViewModal = () => {
		dispatch(clearDesignViewModalInfo({}));
	};

	const openDesignViewModal = () => {
		dispatch(
			setDesignViewModalInfo({
				id: productId,
				onCloseViewModal: onCloseViewModal,
				source: 'PRODUCT_DETAILS'
			})
		);
	};

	return (
		<div className="content">
			<div className="wraper container-fluid">
				<nav className="navbar navbar-expand-lg navbar-light design-tool-header">
					<div className="toggle-menu-btn">
						<a
							onClick={handleGoBackRoute}
							className={loader ? 'back-btn disable' : 'back-btn'}
							href={void 0}
						>
							<img src={`${process.env.PUBLIC_URL}/icons/Left-arrow.svg`} alt="back" />
						</a>
						<button
							className="navbar-toggler"
							type="button"
							data-toggle="collapse"
							data-target="#navbarNavDropdown"
							aria-controls="navbarNavDropdown"
							aria-expanded="false"
							aria-label="Toggle navigation"
						>
							<span className="navbar-toggler-icon" />
						</button>
					</div>
					<div
						className="collapse navbar-collapse one-third-item position-relative"
						id="navbarNavDropdown"
					>
						<ul className="navbar-nav">
							<li
								className={
									loader
										? 'disable'
										: activeTab === 'design'
											? 'nav-item active'
											: 'nav-item'
								}
								onClick={() => handleNavigation('design')}
							>
								<a className="nav-link" href={void 0}>
									Design
								</a>
							</li>
							<li
								className={
									loader
										? 'disable'
										: activeTab === 'materials'
											? 'nav-item active'
											: 'nav-item'
								}
								onClick={() => handleNavigation('materials')}
							>
								<a className="nav-link" href={void 0}>
									Materials
								</a>
							</li>
							<li
								className={
									loader
										? 'disable'
										: activeTab === 'measurement'
											? 'nav-item active'
											: 'nav-item'
								}
								onClick={() => handleNavigation('measurement')}
							>
								<a className="nav-link" href={void 0}>
									Measurement
								</a>
							</li>
							<li
								className={
									loader
										? 'disable'
										: activeTab === 'presentation'
											? 'nav-item active'
											: 'nav-item'
								}
								onClick={() => handleNavigation('presentation')}
							>
								<a className="nav-link" href={void 0}>
									Presentation
								</a>
							</li>
							<li
								className={
									loader
										? 'disable'
										: activeTab === 'costing'
											? 'nav-item active'
											: 'nav-item'
								}
								onClick={() => handleNavigation('costing')}
							>
								<a className="nav-link" href={void 0}>
									Costing
								</a>
							</li>
							<li>
								<a
									onClick={handleGoBackRoute}
									className={loader ? 'back-btn disable' : 'back-btn'}
									href={void 0}
								>
									<img
										src={`${process.env.PUBLIC_URL}/icons/back-arrow-gray.svg`}
										alt="back"
									/>{' '}
									Back to collection
								</a>
							</li>
						</ul>
						{activeTab == 'design' && isShowTooltip && (
							<span className="custom-tooltip position-absolute bottom-0">
								<span className="tooltiptext">
									TP checklist will be placed here(Only first page).
									<br /> Please keep this space empty.
								</span>
							</span>
						)}
					</div>
					<div
						onClick={() => {
							if (saveAllCanvasData) {
								saveAllCanvasData(false, true);
							}
						}}
						className={
							loader
								? 'design-selection-dropdown one-third-item disable'
								: 'design-selection-dropdown one-third-item'
						}
					>
						<div className="dropdown-btn d-flex align-items-center">
							<span className="cursor-pointer mb-1" onClick={() => setOpenModal(true)}>
								<img
									src={`${process.env.PUBLIC_URL}/icons/narrow-view-dark.svg`}
									alt="more"
									className="more-icon"
								/>
							</span>
							<div
								onClick={() => {
									openDesignViewModal();
								}}
							>
								<span className="regular-14 gray_dark_01">/ {referenceNumber}</span>
								{renderProductImage()}
								<span>
									<img
										className="ml-2"
										src={`${process.env.PUBLIC_URL}/icons/down-arrow-gray-dark-02.svg`}
										alt=""
									/>
								</span>
							</div>
						</div>
						{openModal && (
							<DesignSelectionModal
								closeModal={setOpenModal}
								setConvertedImage={setConvertedImage}
							/>
						)}
					</div>

					<div className="profile-and-comments one-third-item">
						<ul className="d-flex">
							{renderDesignSaveStatus && renderDesignSaveStatus()}
							<li>
								{isLiked ? (
									<img
										src={`${process.env.PUBLIC_URL}/icons/favorite.svg`}
										alt="favourite"
										className="add-to-favorite"
									/>
								) : (
									<img
										src={`${process.env.PUBLIC_URL}/icons/not-favorite.svg`}
										alt="not-favourite"
										className="add-to-favorite"
										onClick={() => onLikeProduct()}
									/>
								)}
							</li>
							<li
								className={loader ? 'disable' : ''}
								onClick={() => {
									setOpenCommentPanel(!openCommentPanel);
									setNoOfUnreadMessage(null);
									dispatch(clearAllChats());
								}}
							>
								<Tooltip title="Comments" placement="top" arrow>
									<>
										{(noOfUnreadMessage > 0 ||
											(isNewPost?.id &&
												getUserInfo().id !== isNewPost?.postedBy?.id)) && (
											<img
												src={`${process.env.PUBLIC_URL}/icons/comment-not-read.svg`}
												alt="not read"
											/>
										)}
										{!noOfUnreadMessage &&
											!(
												isNewPost?.id && getUserInfo().id !== isNewPost?.postedBy?.id
											) && (
												<img
													src={`${process.env.PUBLIC_URL}/icons/comments-gray.svg`}
													alt="not read"
												/>
											)}
									</>
								</Tooltip>
							</li>
							<li className={loader ? 'disable' : ''} onClick={() => handleRoute('techpack')}>
								<Tooltip title="Techpack Preview" placement="top" arrow>
									<img src={`${process.env.PUBLIC_URL}/icons/eye.svg`} alt="view" />
								</Tooltip>
							</li>
							<li className={loader ? 'disable' : ''}>
								{getUserInfo() && getUserInfo().profilePicDocument ? (
									<img
										src={getUserInfo()?.profilePicDocument?.docUrl}
										alt="profile"
										className="profile"
										id="dropdownProfile"
										data-toggle="dropdown"
										aria-haspopup="true"
										aria-expanded="false"
									/>
								) : (
									<img
										alt="profile"
										className="profile"
										id="dropdownProfile"
										data-toggle="dropdown"
										aria-haspopup="true"
										aria-expanded="false"
										src={`${process.env.PUBLIC_URL}/images/pro_pic_default.svg`}
									/>
								)}
								<div
									className="dropdown-menu dropdown-menu-right shadow animated--grow-in"
									aria-labelledby="dropdownProfile"
								>
									<Link className="dropdown-item" to="/dashboard">
										<i className="fas fa-tachometer-alt mr-2 text-gray-400 font-12" />
										Dashboard
									</Link>
									<Link className="dropdown-item" to="/my-profile">
										<i className="fas fa-user fa-sm fa-fw mr-2 text-gray-400" />
										Profile
									</Link>
									{/* <Link className="dropdown-item" to="/release-notes">
										Release Notes
									</Link> */}
									<a
										className="dropdown-item cursor-pointer"
										target="_blank"
										href="https://docs.google.com/document/d/1TkvGVCi0MLmea2XRlmBhGXJKCBgrr58iO_XOoWCxdfE/edit"
										rel="noreferrer"
									>
										<i className="fas fa-question-circle mr-2 text-gray-400" />
										Tutorials
									</a>
									<div className="dropdown-divider my-0" />
									<a className="dropdown-item cursor-pointer" onClick={() => logout()}>
										<i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400" />
										Logout
									</a>
								</div>
							</li>
						</ul>
						<div className={`${isShowFavouritePopup ? 'show' : 'hide'}`}>
							<SelectFolderPopup
								onClose={() => setIsShowFavouritePopup(false)}
								isShowCreateNew={isShowCreateNewFolder}
								setIsShowCreateNew={setIsShowCreateNewFolder}
								currentLikedStyle={currentLikedStyle}
							/>
						</div>
					</div>
				</nav>
			</div>
		</div>
	);
};

export default TopHeader;
